<template lang="pug">
  .submit-ideas
    v-container.white.pa-0(style="max-width:600px")
      v-card(flat)
        v-card-text.px-0

          .tabs.mt-n2(v-if="categories.length > 0")
            v-tabs(v-model="selectedTab" color="textColorAccent" height="40" center-active grow right)
              v-tab.button-AA-medium(v-for="t in categories" :key="t.id") {{ t.name }}

          .products
            .background-header
              v-container.white.pb-1(style="max-width:600px")
                div.my-2.mx-2
                  v-text-field(v-model="searchText" placeholder='Search Ideas' hide-details dense outlined height="40" background-color="basic200")
                    template(v-slot:append)
                      eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
                div.my-2.mx-2
                  v-row(no-gutters)
                    v-col
                      v-btn.s1.text-capitalize.px-0(color="textColorAccent" text @click="showAddIdeaDialog = true")
                        eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="20" height="20" style="margin-top: 3px")
                        | {{ $t('submit_new_idea') }}
                  
                    v-col.py-2.shrink
                      v-menu(bottom left offset-y)
                        template(v-slot:activator='{ on }')
                          v-btn.elevation-0.pa-0(text color="transparent" :ripple="false" x-small light v-on='on')
                            v-icon(small color="primary400" size="14" style="margin: 0 2px 0 4px") mdi-sort-descending
                            .label.primary400--text {{ sort.display }}
                        v-list(dense)
                          v-list-item(@click="clickSort({ display: 'popularity', id: 'vote_count'})")
                            v-list-item-title {{ $t('popularity') }}
                          v-list-item(@click="clickSort({ display: 'date', id: 'date_published'})")
                            v-list-item-title {{ $t('date') }}
              v-container.pa-0.mb-4(style="max-width:600px")
                v-layout.my-6(v-if="isFetching")
                  v-row.fill-height.ma-0(align='center' justify='center')
                    v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
                .contain-layout(v-else)
                  v-layout.my-6(v-if="ideas.length == 0")
                    v-row.fill-height.ma-0(align='center' justify='center')
                      div.mx-auto
                        v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                        p.caption {{ $t('be_first_submit_ideas') }}
                  .items-layout.mx-2(v-else)
                    v-divider.basic300
                    template(v-for='(idea, index) in ideas')
                      IdeaItem(:parentIdea="idea")
                y-pagination.ma-4(v-model="page" :pageSize="fetchCount" :count="count")

    .modals
      SubmitNewIdeaDialog(v-if="showAddIdeaDialog" :open.sync="showAddIdeaDialog" @edited="handleEditItem")
          
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import queryString from 'query-string'
import IdeaItem from '@/components/IdeaItem.vue'
import SubmitNewIdeaDialog from '@/components/dialogs/SubmitNewIdea.vue'

export default {
  name: 'SubmitIdeasDialog',
  components:{ IdeaItem, SubmitNewIdeaDialog },
  props: ['open'],
  data: () => ({
    isFetching: false,
    fetchCount: 10,
    page: 1,
    count: 0,
    ideas: [],
    searchCountDown: null,
    searchText: '',
    showAddIdeaDialog: false,
    selectedTab: 0,
    sort: { display: 'popularity', id: 'vote_count'},
    categories: []
  }),
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchIdeas(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    },
    selectedTab () {
      if (!this.isFetching) {
        this.searchItem()
      }
    }
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    searchFilters() {
      let filter = []
      filter.push({"status":{"_eq":"published"}})
      if (this.searchText) {
        filter.push({"search_keywords":{"_contains":this.searchText}})
      }
      if (this.categories.length > 0) {
        const categoryId = this.categories[this.selectedTab].id
        if (categoryId) {
          filter.push({"published_category_id":{"_eq":categoryId}})
        }
      }
      return JSON.stringify({"_and":filter})
    }
  },
  mounted () {
    this.isFetching = true
    this.fetchCategories()
    this.$axios.post(`/members/${this.member.id}/feedback_api_access_token`)
      .then((response) => {
        const accessToken = response.data.access_token
        const user = {}
        user.token = accessToken
        this.$store.commit('user/setFeedbackApiUser', user)
        this.$feedbackApi.get('/users/me')
          .then((response) => {
            const userId = response.data.data.id
            user.id = userId
            this.$store.commit('user/setFeedbackApiUser', user)
            this.$feedbackApi.get(`/items/profiles?filter={"user_id": { "_eq": "${userId}" }}`)
              .then((response) => {
                if (response.data.data.length > 0) {
                  const profile= response.data.data[0]
                  user.profile = profile
                  this.$store.commit('user/setFeedbackApiUser', user)
                }
              }).catch(() => {})
              .finally(() => { this.fetchIdeas(1) })
          }).catch(() => {})
      }).catch(() => {})
  },
  methods:{
    clickSort (val) {
      this.sort = val
      this.fetchIdeas(1)
    },
    fetchCategories () {
      this.$feedbackApi.get('/items/categories?filter={ "show_in_tabs": { "_eq": "true" }}')
        .then((response) => {
          this.categories = [ ...response.data.data ]
          if (this.categories.length > 0) {
            this.categories.splice(0, 0, {id: null, name: 'ALL'})
          }
        }).catch(() => {})
    },
    fetchIdeas(page) {
      this.page = parseInt(page)
      this.isFetching = true
      this.$feedbackApi.get(`/items/feedbacks?fields=*.*&meta=filter_count&limit=${this.fetchCount}&page=${this.page}&filter=${this.searchFilters}&sort=-${this.sort.id}`).then((response) => {
        this.isFetching = false
        this.ideas = response.data.data
        this.count = response.data.meta.filter_count
      })
      .catch(() => {})
    },
    searchItem () {
      this.isFetching = true
      this.page = 1
      this.$feedbackApi.get(`/items/feedbacks?fields=*.*&meta=filter_count&limit=${this.fetchCount}&page=${this.page}&filter=${this.searchFilters}&sort=-${this.sort.id}`)
        .then((response) => {
          this.isFetching = false
          this.ideas = response.data.data
          this.count = response.data.meta.filter_count
        })
        .catch(() => {})
    },
    handleEditItem (item) {
      let addToIndex = 0
      this.ideas.forEach((rider, index) => {
        if (rider.id === item.id) {
          addToIndex = index
        }
      })
      this.ideas = this.ideas.filter((x) => x.id !== item.id)
      this.ideas.splice(addToIndex, 0, item)
    }
  },
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "submit_new_idea": "Submit New Idea",
    "popularity": "Popularity",
    "be_first_submit_ideas": "Be the first to submit new ideas"
  },
  "id": {
    "submit_new_idea": "Tambah Kritik dan Saran",
    "popularity": "Popularitas",
    "be_first_submit_ideas": "Jadilah yang pertama mengirimkan ide-ide baru"
  }
}
</i18n>
